<script setup lang="ts">
import { usePage } from '@inertiajs/vue3'

// Devise sends empty messages for notices the app doesn't show, so only non-empty ones render.
const page = usePage()
</script>

<template>
  <v-alert
    v-if="page.flash.notice"
    color="primary-tint"
    icon="mdi-check-circle-outline"
    density="compact"
    :text="page.flash.notice"
  />
  <v-alert
    v-if="page.flash.alert"
    color="danger-tint"
    icon="mdi-alert-circle-outline"
    density="compact"
    :text="page.flash.alert"
  />
</template>
